import { FontAwesomeConfigurations } from '../../utils/Configuration/FontAwesomeConfiguration';
import './SocialLikeContainer.scss';
export default class SocialLikeContainer {
  mDiv: JQuery<HTMLElement>;
  constructor() {}
  initialize(aConstructorParams): void {
    let text = aConstructorParams.text;
    let likeCount = aConstructorParams.count;
    let parentContainer = aConstructorParams.container;
    this.mDiv = $(
      HGEN.tree({
        style: 'social_like_container',
        children: [
          {
            style: 'social_like_container_icon',
            interior: HGEN.faicon({
              style: FontAwesomeConfigurations.ICON_THUMBS_UP_REGULAR,
            }),
          },
          {
            style: 'social_like_container_count',
            interior: likeCount,
          },
          { style: 'social_like_container_text', interior: text },
        ],
      }),
    );
    parentContainer.append(this.mDiv);
  }
}
